import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogError, DialogFooter, DialogHeader, DialogLoading } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { Content } from './Content';
import { useRequirementChecked } from './useRequirementChecked';
export function RequirementCheckedDialog(props) {
    const { userName, timestamp, documentChatId, onClose } = props;
    const { requirementCheckedState } = useRequirementChecked(documentChatId);
    const formattedTimestamp = localizedFormatDate(timestamp, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    });
    const subtitle = t({
        message: `Started by ${userName} on ${formattedTimestamp}`,
        comment: 'Approval requirement check dialog - Subtitle',
    });
    return (<Dialog>
      <DialogHeader icon={<Falcon icon="eye"/>} title={t({
            message: 'Approval requirement check',
            comment: 'Approval requirement check dialog - Title',
        })} subtitle={subtitle}/>
      {requirementCheckedState.type === 'loading' && <DialogLoading />}

      {requirementCheckedState.type === 'error' && (<DialogError title={t({ message: 'Error', comment: 'Approval requirement check dialog - Error title' })} description={t({
                message: 'Something went wrong while loading the dialog, please try again.',
                comment: 'Approval requirement check dialog - Error description',
            })} actions={<Button type="button" appearance="secondary" size="small" onClick={onClose}>
              <Trans comment="Approval requirement check dialog - Close button label">Close</Trans>
            </Button>}/>)}

      {requirementCheckedState.type === 'finished' && (<Content plaiResponse={requirementCheckedState.plaiResponse} additionalContext={requirementCheckedState.additionalContext} promptUsed={requirementCheckedState.promptUsed}/>)}
      <DialogFooter>
        <Button size="small" appearance="secondary" onClick={onClose}>
          <Trans comment="Approval requirement check dialog - Close button label">Close</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
